export default __webpack_public_path__ + "static/topic16-9a20a301b4118dea9b029e5b1ae6bdcd.png";